// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iframe-wrapper {
  position: relative;
  width: 100%;
  height: 100vh; /* ou autre hauteur */
  overflow: hidden; /* cache le haut */
}

.iframe-landing {
  position: relative;
  top: -70px; /* décale le contenu vers le haut pour masquer le header */
  width: 100%;
  height: calc(100% + 70px); /* compense le décalage */
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Accueil/Accueil.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,qBAAqB;EACpC,gBAAgB,EAAE,kBAAkB;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,0DAA0D;EACtE,WAAW;EACX,yBAAyB,EAAE,yBAAyB;EACpD,YAAY;AACd","sourcesContent":[".iframe-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100vh; /* ou autre hauteur */\n  overflow: hidden; /* cache le haut */\n}\n\n.iframe-landing {\n  position: relative;\n  top: -70px; /* décale le contenu vers le haut pour masquer le header */\n  width: 100%;\n  height: calc(100% + 70px); /* compense le décalage */\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
